import React from 'react';
import { Input } from '@attentive-platform/stem-ui';

import ExampleCards, { normalizeExampleUrls } from './ExampleCards';
import ModifierInput from './ModifierInput';
import { TradeDetailingBlockStyles as S } from './styles';

const isVisibleTradeModifier = m =>
  m &&
  m.modifier_type !== 'example' &&
  (m.title || m.body || (m.answer_options || []).length || normalizeExampleUrls(m.urls).length);

const hasUrls = m => normalizeExampleUrls(m?.urls).length > 0;

const TradeDetailingBlock = ({
  trade,
  modifierAnswers,
  onModifierChange,
  noteValue,
  onNoteChange,
  readOnly
}) => {
  const allTradeMods = trade.trade_modifiers || [];
  const tradeMods = allTradeMods.filter(isVisibleTradeModifier);
  const exampleMods = allTradeMods.filter(m => m && m.modifier_type === 'example');
  const tradeNameLower = (trade.trade_name || 'this trade').toLowerCase();

  if (!tradeMods.length && !exampleMods.length && readOnly && !(noteValue || '').trim()) return null;

  return (
    <S.Card>
      {(tradeMods.length > 0 || exampleMods.length > 0 || !readOnly) && (
        <S.Header>
          <S.Heading>Detailing &amp; deliverables</S.Heading>
          <S.Description>
            A few last questions about how you want {tradeNameLower} reported. These apply to the whole trade.
          </S.Description>
        </S.Header>
      )}

      {tradeMods.map(m => (
        <S.ModifierRow key={m.id}>
          <ModifierInput
            modifier={m}
            value={modifierAnswers[m.id]}
            onChange={patch => onModifierChange(m.id, patch)}
            readOnly={readOnly}
          />
          {hasUrls(m) && <ExampleCards modifiers={[m]} />}
        </S.ModifierRow>
      ))}

      {exampleMods.length > 0 && (
        <S.ModifierRow>
          <ExampleCards modifiers={exampleMods} />
        </S.ModifierRow>
      )}

      {(!readOnly || (noteValue || '').trim()) && (
        <S.NoteBlock>
          <S.NoteTitle>Anything else we should know about how you bid this trade?</S.NoteTitle>
          {!readOnly && (
            <S.NoteHint>Optional. This note is local — your account team will see it after you submit.</S.NoteHint>
          )}
          <Input
            size='large'
            multiline
            minRows={readOnly ? 2 : 4}
            value={noteValue || ''}
            onChange={e => onNoteChange(e.target.value)}
            disabled={readOnly}
            placeholder='e.g. we bid slab-on-grade separately from structural — keep them on different lines.'
          />
        </S.NoteBlock>
      )}
    </S.Card>
  );
};

export default TradeDetailingBlock;
